import React, { Fragment } from 'react';
import { Button, Divider, Dropdown, Form } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import generateTestId from 'packages/helpers/testIdHelpers';
import useAccessRights from 'packages/hooks/useAccessRights';
import { FormSectionContent } from 'packages/pages/editor/RightSideMenu/index.styled';
import { EXPORT_TYPE_OPTIONS, exportTypes } from './enums';
import { useExportSettings } from './useExportSettings';
import { ExportSettingsOption } from './ExportSettings.styled';
import features from 'packages/configs/features';

export const ExportSettings = () => {
    const { translate } = useTranslate();
    const { handleExportTypeClick, chosenExportValue } = useExportSettings();
    const { isPlatformAllowed } = useAccessRights();

    const testId = generateTestId('global_export_settings');
    const exportOptions = EXPORT_TYPE_OPTIONS.filter((option) =>
        !isPlatformAllowed([features.BYNDER_WAITING_ROOM_UPLOAD]) ? option.name === exportTypes.DOWNLOAD : true,
    );

    return (
        <FormSectionContent onSubmit={(event) => event.preventDefault()}>
            <Form.Group>
                <Form.Label>{translate('editor.export-settings.title')}</Form.Label>
                <Dropdown
                    position="bottom"
                    trigger={({ isOpen, ...triggerProps }) => (
                        <Button
                            isPressed={isOpen}
                            rightIcon={<Dropdown.Arrow />}
                            isFullWidth
                            {...triggerProps}
                            {...testId}
                        >
                            <Dropdown.SelectButtonText>{chosenExportValue.title}</Dropdown.SelectButtonText>
                        </Button>
                    )}
                >
                    {exportOptions.map((item, idx) => (
                        <Fragment key={item.name}>
                            <ExportSettingsOption
                                isChecked={chosenExportValue.name === item.name}
                                onClick={() => {
                                    handleExportTypeClick(item.name);
                                }}
                                subtext={item.description}
                            >
                                {item.title}
                            </ExportSettingsOption>
                            {idx !== exportOptions.length - 1 && <Divider />}
                        </Fragment>
                    ))}
                </Dropdown>
                <Form.HelperText>{translate('editor.export-settings.description')}</Form.HelperText>
            </Form.Group>
        </FormSectionContent>
    );
};
